import React from 'react';
import { Link } from 'react-router-dom';
import { FONT_MONO, FONT_SERIF, TRUSTED_BY } from './landingData';

const tw = (v: string) => ({ textWrap: v } as React.CSSProperties);
const tile: React.CSSProperties = { display: 'flex', alignItems: 'center', justifyContent: 'center', height: 96, padding: '0 28px', borderRadius: 18, background: '#FEFEFC', border: '1px solid var(--hv-line)', boxShadow: '0 24px 40px -36px var(--hv-shadow)', transition: 'transform 0.35s cubic-bezier(0.2,0.9,0.24,1),border-color 0.2s ease', maxWidth: '100%', boxSizing: 'border-box' };

/**
 * Logo strip under the testimonial: organisations that build and publish with
 * HyVay. Logos sit on a fixed light tile (not a theme token) because most brand
 * marks are drawn for a white background and would vanish on the dark theme.
 */
export const TrustedBySection: React.FC = () => (
    <section data-screen-label="Trusted by" style={{ padding: '0 0 64px', background: 'var(--hv-page-2)' }}>
        <div className="hv-shell" style={{ maxWidth: 1280, margin: '0 auto', padding: '0 28px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 18, marginBottom: 26 }}>
                <span style={{ flex: 1, height: 1, background: 'var(--hv-line)' }} />
                <span style={{ fontFamily: FONT_MONO, fontSize: 10, letterSpacing: '0.18em', textTransform: 'uppercase', color: 'var(--hv-muted)', whiteSpace: 'nowrap' }}>Trusted by</span>
                <span style={{ flex: 1, height: 1, background: 'var(--hv-line)' }} />
            </div>
            <p style={{ margin: '0 auto 28px', maxWidth: 520, textAlign: 'center', fontFamily: FONT_SERIF, fontSize: 24, lineHeight: 1.25, letterSpacing: '-0.01em', color: 'var(--hv-ink)', ...tw('balance') }}>
                Organisations that already <i>build and publish</i> with HyVay
            </p>
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center', gap: 16 }}>
                {TRUSTED_BY.map((o) => {
                    // External URLs (and anything marked target: '_blank') open in a new tab so the landing stays put.
                    const external = /^https?:\/\//i.test(o.href);
                    const newTab = o.target === '_blank' || (external && o.target !== '_self');
                    const img = <img src={o.img} alt={o.name} width={o.w} height={o.h} loading="lazy" decoding="async" style={{ height: 64, width: 'auto', maxWidth: '100%', display: 'block', objectFit: 'contain' }} />;
                    return external ? (
                        <a key={o.name} href={o.href} title={o.name} target={newTab ? '_blank' : undefined} rel={newTab ? 'noopener noreferrer' : undefined} className="hv-h-lift" style={tile}>{img}</a>
                    ) : (
                        <Link key={o.name} to={o.href} title={o.name} target={newTab ? '_blank' : undefined} rel={newTab ? 'noopener noreferrer' : undefined} className="hv-h-lift" style={tile}>{img}</Link>
                    );
                })}
            </div>
        </div>
    </section>
);
